import type { ReactElement, ReactNode } from 'react';

interface MetaRowProps {
  readonly label: string;
  readonly value: ReactNode;
}

/** Small label-over-value row used by the panel for program / referral source. */
export function MetaRow({ label, value }: MetaRowProps): ReactElement {
  return (
    <div className="flex items-baseline gap-2 px-4 py-2.5 border-b border-border last:border-b-0">
      <span className="text-[10.5px] font-semibold uppercase tracking-[0.06em] text-muted-foreground w-16 shrink-0">
        {label}
      </span>
      <span className="text-[13px] text-foreground min-w-0 break-words flex-1">
        {value}
      </span>
    </div>
  );
}
